import { createFileRoute } from "@tanstack/react-router";
import ScBluesInsurance, { config } from "@/pages/ScBluesInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/sc-blues-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "South Carolina Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "South Carolina Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "South Carolina Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "South Carolina Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/sc-blues-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/sc-blues-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ScBluesInsurance />;
}
